import(/* webpackMode: "eager" */ "/var/www/azia_frontv2_v3/src/app/global-error.tsx");
